import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAlarmNotesAsync, getAlarmRecordingUrlAsync } from './asyncActions';
import { updateAlarmNotesData } from './operations';

export interface AlarmState {
  alarmNotes: {
    data: null | any;
    status: null | 'idle' | 'loading' | 'failed';
  };
  alarmRecordingUrl: {
    data: null | any;
    status: null | 'idle' | 'loading' | 'failed';
  };
}

const initialState: AlarmState = {
  alarmNotes: {
    data: [],
    status: null,
  },
  alarmRecordingUrl: {
    data: [],
    status: null,
  },
};

export const alarmSlice = createSlice({
  name: 'alarm',
  initialState,
  reducers: {
    updateAlarmNotes: (state, { payload }: PayloadAction<any>) => {
      state.alarmNotes.data = updateAlarmNotesData(payload, state.alarmNotes.data);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAlarmNotesAsync.pending, (state) => {
        state.alarmNotes.status = 'loading';
      })
      .addCase(getAlarmNotesAsync.fulfilled, (state, action) => {
        state.alarmNotes.status = 'idle';
        state.alarmNotes.data = action.payload?.data;
      })
      .addCase(getAlarmNotesAsync.rejected, (state) => {
        state.alarmNotes.status = 'failed';
      })
      .addCase(getAlarmRecordingUrlAsync.pending, (state) => {
        state.alarmRecordingUrl.status = 'loading';
      })
      .addCase(getAlarmRecordingUrlAsync.fulfilled, (state, action) => {
        state.alarmRecordingUrl.status = 'idle';
        state.alarmRecordingUrl.data = action.payload?.data.item;
      })
      .addCase(getAlarmRecordingUrlAsync.rejected, (state) => {
        state.alarmRecordingUrl.status = 'failed';
      });
  },
});

export const { updateAlarmNotes } = alarmSlice.actions;

export default alarmSlice.reducer;
